import { filterTripCartItems } from "@app/modules/checkout/utils/cart-v2";
import type { CheckoutCommonReduxState } from "@app/types/checkout-v2-types";

export const getCartItemsTripId = (state: CheckoutCommonReduxState): string => {
  // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  return filterTripCartItems(state.cart.items)[0].id;
};
